import { Box, Grid, IconButton, Paper, TableCell, TextField, Tooltip, Typography } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { invokeIfCallable } from '../../../library/shared';
import pdf from '../../../assets/images/attachments/pdf.png';
import excel from '../../../assets/images/attachments/excel.jpeg';
import ppt from '../../../assets/images/attachments/ppt.png';
import docx from '../../../assets/images/attachments/docs1.png';
import ImgModal from '../../PrimeFigma/Modals/imgModal';
import { useThemes } from '../../../components/Theme/theme';
import { useLocation } from 'react-router-dom';

const Attachment = ({ attachments, view, setAttachments, updateAttachmentName, setDeleted }) => {
  const { theme } = useThemes();
  const [bool, setBool] = useState(false);
  const [editRow, setRowId] = useState(null);
  const nameRef = useRef(null);
  const location = useLocation();
  const viewPage = location.pathname.includes('view');
  const removeAttachment = (attachmentId) => {
    if (attachments.find((elem) => elem.attachmentid == attachmentId && !elem.file)) {
      invokeIfCallable(setDeleted, 0, attachmentId);
    }
    setAttachments(attachments.filter((attachment) => (attachment.attachmentid || attachment.id) !== attachmentId));
  };
  useEffect(() => {
    if (nameRef.current) {
      nameRef.current.focus(); // Focus the input element
    }
  }, [bool]);
  const editAttachment = (attachmentId) => {
    if (bool === false) {
      setRowId(attachmentId);
      setBool(true);
    } else {
      setBool(false);
    }
  };

  const handleEditEnterClick = (e) => {
    if (e.key === 'Enter') {
      setBool(false);
    }
  };
  const getFileNameWithoutExtension = (fileName) => {
    const withoutExt = fileName?.replace(/\.[^/.]+$/, '');
    let file;
    if (withoutExt?.length >= 15) {
      file = withoutExt?.substring(0, 15);
    } else {
      file = withoutExt;
    }
    return file;
  };
  const date = new Date();

  return (
    <Grid container xs={12}>
      <Grid item md={2.5} lg={2} sx={{ display: { xs: 'none', lg: 'block' } }}>
        <Box
          sx={{
            background: theme.palette.background.tablebg,
            fontSize: '14px',
            textAlign: 'center',
            fontWeight: 'bold',
            width: '150px',
          }}
        >
          <Typography sx={{ marginTop: '4px' }}>
            <TableCell sx={{ color: view ? 'rgba(0, 0, 0, 0.38)' : '#595C66', fontWeight: 'bold', padding: '6px 16px' }}>
              Document Name
            </TableCell>
          </Typography>
          <Typography>
            <TableCell
              sx={{
                height: '65px',
                display: 'flex',
                alignItems: 'center',
                fontWeight: 'bold',
                padding: '8px 16px',
                color: view ? 'rgba(0, 0, 0, 0.38)' : '#595C66',
              }}
            >
              File
            </TableCell>
          </Typography>
          <Typography sx={{ marginTop: '-3px' }}>
            <TableCell
              sx={{
                fontWeight: 'bold',
                padding: '10px 16px',
                color: view ? 'rgba(0, 0, 0, 0.38)' : '#595C66',
              }}
            >
              Uploaded on
            </TableCell>
          </Typography>
        </Box>
      </Grid>
      <Grid
        item
        xs={12}
        md={9.5}
        lg={10}
        sx={{
          '&.MuiGrid-root': {
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
          },
        }}
      >
        {attachments?.map((attachment) => {
          const image =
            attachment?.imagename?.endsWith('pdf') || attachment?.type?.endsWith('pdf')
              ? pdf
              : attachment?.imagename?.endsWith('sheet') ||
                attachment?.imagename?.endsWith('xlsx') ||
                attachment?.imagename?.endsWith('xls') ||
                attachment?.type?.endsWith('xlsx') ||
                attachment?.type?.endsWith('sheet')
              ? excel
              : attachment?.imagename?.endsWith('document') ||
                attachment?.type?.endsWith('document') ||
                attachment?.imagename?.endsWith('docx') ||
                attachment?.imagename?.endsWith('doc')
              ? docx
              : attachment?.imagename?.endsWith('pptx') ||
                attachment?.imagename?.endsWith('ppt') ||
                attachment?.imagename?.endsWith('ppa') ||
                attachment?.type?.endsWith('pptx') ||
                attachment?.imageurl?.endsWith('pptx')
              ? ppt
              : attachment.imageurl;
          const imgBool =
            attachment?.imagename?.endsWith('pdf') || attachment?.type?.endsWith('pdf')
              ? pdf
              : attachment?.imagename?.endsWith('sheet') ||
                attachment?.imagename?.endsWith('xlsx') ||
                attachment?.imagename?.endsWith('xls') ||
                attachment?.type?.endsWith('xlsx') ||
                attachment?.type?.endsWith('sheet')
              ? excel
              : attachment?.imagename?.endsWith('pptx') ||
                attachment?.imagename?.endsWith('ppt') ||
                attachment?.imagename?.endsWith('ppa') ||
                attachment?.type?.endsWith('pptx') ||
                attachment?.imageurl?.endsWith('pptx')
              ? ppt
              : attachment?.imagename?.endsWith('document') ||
                attachment?.type?.endsWith('document') ||
                attachment?.type?.endsWith('doc') ||
                attachment?.imagename?.endsWith('docx');
          return (
            <Grid item lg={3} xs={6} key={attachment.attachmentid || attachment.id} sx={{ padding: '0px 8px' }}>
              <Paper
                elevation={3}
                style={{
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  height: '153px',
                  marginTop: '1px',
                  justifyContent: 'space-around',
                }}
                sx={{
                  '@media (max-width: 900px)': {
                    width: '150px',
                  },
                  '@media (max-width: 1200px)': {
                    width: '110px',
                  },
                }}
              >
                <Box sx={{ height: '30px' }}>
                  {editRow === (attachment.attachmentid || attachment.id) && bool ? (
                    <TextField
                      inputRef={nameRef}
                      size="small"
                      defaultValue={getFileNameWithoutExtension(attachment.documentname)}
                      fullWidth
                      onChange={(e) => {
                        const value = e.target.value;
                        console.log(attachment.attachmentid, 'attachment.attachmentid');
                        if (value.length <= 15) {
                          updateAttachmentName(attachment.attachmentid || attachment.id, value);
                        }
                      }}
                      value={
                        bool === true ? getFileNameWithoutExtension(attachment.documentname) : attachment.documentname.substring(0, 15)
                      }
                      sx={{
                        borderWidth: '3px',
                        '& .MuiInputBase-input-MuiOutlinedInput-input': {
                          border: 'none',
                        },
                      }}
                      onKeyDown={(e) => handleEditEnterClick(e)}
                      onBlur={() => setBool(false)}
                    />
                  ) : (
                    <span
                      style={{
                        padding: '0px 3px',
                        width: '115px',
                        wordWrap: 'break-word',
                        fontSize: '13px',
                        fontWeight: 'bold',
                      }}
                    >
                      {getFileNameWithoutExtension(attachment.documentname)}
                    </span>
                  )}
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
                  <Box>
                    <ImgModal
                      image={image}
                      ImageURL={attachment.imageurl}
                      imgBool={imgBool}
                      pdf={
                        attachment?.type?.endsWith('pdf') ||
                        attachment?.type?.endsWith('jpg') ||
                        attachment?.type?.endsWith('jpeg') ||
                        attachment?.type?.endsWith('png')
                      }
                    />
                  </Box>
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <IconButton
                      disabled={view ? true : false}
                      disableRipple
                      aria-label="delete"
                      sx={{
                        margin: '2px',
                        padding: '5px',
                        backgroundColor: '#b1d1f97d',
                      }}
                      onClick={() => {
                        console.log(attachment.attachmentid, ' attachment.attachmentid');
                        const id = attachment.attachmentid === 0 || attachment.attachmentid ? attachment.attachmentid : attachment.id;
                        editAttachment(id);
                      }}
                    >
                      {editRow === (attachment.attachmentid || attachment.id) && bool ? (
                        <Tooltip title={viewPage ? '' : 'Save'} placement="right-start">
                          <DoneIcon
                            sx={{
                              fontSize: '15px',
                              color: '#34994f',
                            }}
                          />
                        </Tooltip>
                      ) : (
                        <Tooltip title={viewPage ? '' : 'Edit'} placement="right-start">
                          <EditIcon
                            sx={{
                              fontSize: '15px',
                              color: '#6096d9',
                            }}
                          />
                        </Tooltip>
                      )}
                    </IconButton>

                    <IconButton
                      disabled={view ? true : false}
                      disableRipple
                      aria-label="delete"
                      sx={{
                        margin: '0px 2px',
                        padding: '5px',
                        backgroundColor: '#fbc7c78c',
                      }}
                      onClick={() => removeAttachment(attachment.attachmentid || attachment.id)}
                    >
                      <Tooltip title={viewPage ? '' : 'Delete'} placement="right-start">
                        <DeleteIcon
                          sx={{
                            fontSize: '15px',
                            color: '#bb0909',
                          }}
                        />
                      </Tooltip>
                    </IconButton>
                  </Box>
                </Box>
                <Typography variant="body2" sx={{}}>
                  {' '}
                  {attachment.enteredtimestamp
                    ? moment(attachment.enteredtimestamp * 1000).format('DD-MM-YYYY')
                    : moment(date).format('DD/MM/YYYY')}
                </Typography>
              </Paper>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default Attachment;
